import { useState, useEffect, useMemo, useCallback } from "react";
import SidePanel from "../../components/SidePanel";
import { Link, useParams } from "react-router-dom";
import Spinner from "../../components/Spinner";
import ConfirmationModal from "../../components/ConfirmationModal";
import Upload_Picture from "../../assets/icons/Upload_Picture.svg";
import remove_recipient from "../../assets/icons/remove_recipient.svg";
import { format } from "date-fns";
import MultiSwiper from "../../components/MultiSwiper";
import { SwiperSlide } from "swiper/react";
import useAllActiveEvents from "../../hooks/useAllActiveEvents";
import Modal from "../../components/Modal";
import { IoCloseSharp } from "react-icons/io5";
import { getAdjustedEventDate } from "../../utils/sendToPrint";
import { toast } from "react-toastify";
const dateKeys = {
  Graduation: "graduationDate",
  "House Warming": "housewarmingDate",
  "Baby Shower": "babyshowerDate",
  "Occasion Anniversary": "occasionanniversaryDate",
};

const RecipientDetails = () => {
  const { id } = useParams();
  const { loading, allEvents, error } = useAllActiveEvents();
  const [occasions, setOccasions] = useState([]);
  const [recipients, setRecipients] = useState({});
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [removeModal, setRemoveModal] = useState(false);
  const [cards, setCards] = useState([]);
  const [cardId, setCardId] = useState([]);
  const [selectedID, setSelectedID] = useState();
  const [loader, setLoader] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRecipient, setSelectedRecipient] = useState("");
  const [currentEventId, setCurrentEventId] = useState("");
  const [selectedCardThumbnail, setSelectedCardThumbnail] = useState("");
  const [cardImages, setCardImages] = useState({});
  const [eventDate, setEventDate] = useState("");
  const [eventName, setEventName] = useState("");
  const token = localStorage.getItem("token");
  const [imageLoading, setImageLoading] = useState({
    0: false,
    1: true,
    2: true,
    3: true,
  });

  const [cardDetails, setCardDetails] = useState({
    eventOfRecipientId: "",
    textCard: "",
    eventId: {},
    cardStatus: "",
    textTo: "",
    textFrom: "",
    messageTheme: "",
    createdAt: "",
    cardId: {},
    receiptsId: {},
  });
  const [currentPage, setCurrentPage] = useState(0);
  const toggleDetailsModal = () => {
    setSelectedRecipient("");
    setCurrentEventId("");
    setEventDate("");
    setCardDetails({
      eventOfRecipientId: "",
      textCard: "",
      cardStatus: "",
      textTo: "",
      textFrom: "",
      messageTheme: "",
      createdAt: "",
      cardId: {},
      receiptsId: {},
      eventId: {},
    });
    setDetailsModal((prev) => !prev);
  };
  const [isisLoading, setIsLoading] = useState(false);
  const eventDateWithCurrentYear = useMemo(() => {
    if (eventDate && cardDetails.createdAt) {
      return getAdjustedEventDate(
        eventDate,
        cardDetails.createdAt,
        {},
        cardDetails
      );
    }
  }, [eventDate, cardDetails.createdAt]);
  const getImgSrc = (page) => {
    const placeholders = {
      0: selectedCardThumbnail,
      // 1:
      //   cardImages.page2 || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF",
      1:
        cardImages.page3 || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF",
      2: cardImages.last || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF",
    };
    return (
      placeholders[page] || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF"
    );
  };
  const handleImageLoad = (page, error = false) => {
    if (error) {
      console.log(`Failed to load image for page ${page}`);
    }
    setImageLoading((prev) => ({ ...prev, [page]: false }));
  };
  const handleImageError = () => {
    setImageLoaded(true);
  };
  useEffect(() => {
    setImageLoading((prev) => ({ ...prev, [currentPage]: true }));
  }, [currentPage]);

  const toggleRemoveModal = () => {
    setRemoveModal(!removeModal);
  };

  useEffect(() => {
    const fetchRecipients = async (customerID, token) => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/get-customer-recipients/${customerID}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        const recipientData = data.data.find(
          (recipient) => recipient._id === id
        );
        setSelectedOccasions(
          recipientData?.eventsId?.map((occasion) => ({
            value: occasion._id,
            label: occasion.name,
          }))
        );
        setRecipients(recipientData || {});
      } catch (error) {
        console.error("Failed to fetch recipients", error);
      } finally {
        setLoader(false);
      }
    };
    const customerID = localStorage.getItem("ID");
    const token = localStorage.getItem("token");
    if (customerID && token) {
      fetchRecipients(customerID, token);
    }
  }, [id]);

  useEffect(() => {
    const fetchCards = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-recipient-cards/${id}?status=all`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        if (recipients?.fullName === data.data[0]?.receiptsId.fullName) {
          const cardIds = data.data.map((card) => card.cardId._id);
          setCardId(cardIds);
        }
        setCards(data.data);
      } catch (error) {
        console.error("Failed to fetch cards", error);
      }
    };
    if (recipients?.fullName) {
      fetchCards();
    }
  }, [recipients]);

  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const res = await response.json();
        if (res.code === 200) {
          setOccasions(res.data);
        }
      } catch (error) {
        toast.error("Failed to fetch occasions.");
      }
    };
    fetchOccasions();
  }, [token]);

  const handleScroll = (direction) => {
    setCurrentPage((prevPage) => {
      if (direction === "next" && prevPage < 3) {
        return prevPage + 1;
      } else if (direction === "prev" && prevPage > 0) {
        return prevPage - 1;
      }
      return prevPage;
    });
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [detailsModal]);

  useEffect(() => {
    console.log({ currentEventId, occasions });
    if (occasions && currentEventId) {
      const foundEvent = occasions.find(
        (occasion) => occasion._id === currentEventId
      );
      setEventName(foundEvent?.name || "");
    }
  }, [occasions, currentEventId]);
  const fetchCardDetails = useCallback(
    async (to, cont, _from) => {
      if (!to || !cont || !_from) {
        toast.error("Missing card details for generation.");
        return;
      }
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/generate-temp-card-png`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
            body: JSON.stringify({
              greeting: to,
              body: cont,
              signoff: _from,
            }),
          }
        );
        const res = await response.json();
        if (res.code === 200) {
          setCardImages(res.data);
        } else {
          toast.error("Failed to generate card.");
        }
      } catch (error) {
        toast.error("Error while generating card.");
      } finally {
        setIsLoading(false);
      }
    },
    [token]
  );
  const handleDeleteRecipient = async (ID) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/recipient/delete-recipient/${ID}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      if (res.status === 200) {
        setRecipients({});
        toggleRemoveModal();
        window.location.href = "/dashboard/address_book";
      }
    } catch (error) {
      console.error("Failed to delete recipient", error);
    }
  };

  if (loader) {
    return (
      <section className="flex">
        <SidePanel />
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div className="flex items-center justify-center w-full h-screen m-10">
            <Spinner props={"Loading"} size={100} />
          </div>
        </div>
      </section>
    );
  }
  const dateInputs = selectedOccasions.map((occasion) => {
    const { label } = occasion;
    return (
      <li key={label} className="text-lg md:text-xl">
        <span className="font-semibold text-primary">{label}</span>
        {/* <span className="text-gray-700">Not included in dateKeys</span> */}
      </li>
    );
  });
  const isLoading = loading;
  return (
    <section className="flex flex-col md:flex-row px-4 sm:px-2 mx-auto">
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h3 className="mb-5">
          <Link to="/dashboard/address_book" className="hover:underline">
            Address Book
          </Link>
          {">"} <span className="text-primary">Recipient Details</span>
        </h3>
        <div className="bg-[#F1F1F1] p-5 rounded-md my-5">
          <div className="flex flex-col md:flex-row items-start">
            <div
              className={`relative my-5  flex-shrink-0 z-20 rounded-md cursor-pointer border-transparent hover:border hover:border-primary hover:shadow-md transition duration-300 ease-in-out`}
            >
              {recipients?.profile_image ? (
                <img
                  src={recipients.profile_image}
                  alt="Recipient's Profile"
                  className="object-cover w-52 h-52 rounded-lg"
                />
              ) : (
                <Link to={`/dashboard/address_book/edit/${id}`}>
                  <img
                    src={Upload_Picture}
                    alt="Upload Placeholder"
                    className="object-cover w-24 h-24 rounded-lg cursor-pointer"
                  />
                </Link>
              )}
            </div>

            <div className="flex flex-col w-full py-3 md:p-3">
              <div className="flex flex-col md:flex-row justify-between w-full mt-5 md:items-start md:mb-5">
                <div>
                  <h3 className="mb-4 text-2xl text-secondary font-semibold md:text-3xl">
                    {recipients?.fullName}
                  </h3>
                  <div className="flex flex-col text-xl lg:hidden gap-y-1">
                    <p className="text-[#F39028] uppercase">
                      Gender-{" "}
                      <span className="capitalize">{recipients?.gender}</span>
                    </p>
                    <p className="text-md ">
                      Age-
                      {Math.floor(
                        (new Date() - new Date(recipients?.dob).getTime()) /
                          3.15576e10
                      )}
                    </p>
                    <p className="text-[#26ABA4]">
                      Relationship-{recipients?.relationShip}
                    </p>
                    <p className="text-[#942c3a]">
                      Occasion -{" "}
                      {recipients?.eventsId?.map((item, index) => {
                        if (index === recipients?.eventsId.length - 1) {
                          return <span key={index}> {item.name}</span>;
                        } else {
                          return <span key={index}> {item.name},</span>;
                        }
                      })}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row gap-3 md:items-center md:w-full lg:w-1/2">
                  <button
                    onClick={() => {
                      setSelectedID(recipients._id);
                      toggleRemoveModal();
                    }}
                    className="flex items-center justify-center w-full py-2 text-white border-2 rounded-sm border-primary bg-primary hover:bg-primary-dark gap-x-3"
                  >
                    Remove
                  </button>
                  <Link
                    to={`/dashboard/address_book/edit/${id}`}
                    className="w-full"
                  >
                    <button className="flex items-center justify-center w-full py-2 border-2 rounded-sm border-primary text-primary  hover:bg-primary-light gap-x-3">
                      Edit
                    </button>
                  </Link>
                </div>
              </div>

              <div className="items-center hidden text-xl lg:flex gap-x-5">
                <p className="text-[#F39028] capitalize">
                  Gender-{recipients?.gender}
                </p>
                <p className="text-md">
                  Age-{" "}
                  {Math.floor(
                    (new Date() - new Date(recipients?.dob).getTime()) /
                      3.15576e10
                  )}
                </p>
                <p className=" text-[#26ABA4]">
                  Relationship-{recipients?.relationShip}
                </p>
                {/* <p className="text-[#942c3a]">
                  Occasion -{" "}
                  {recipients?.eventsId?.map((item, index) => {
                    if (index === recipients?.eventsId.length - 1) {
                      return <span key={index}> {item.name}</span>;
                    } else {
                      return <span key={index}> {item.name},</span>;
                    }
                  })}
                </p> */}
              </div>
            </div>
          </div>
          <div className="border-b-[1.5px] border-black my-5" />
          <div className="flex flex-col md:flex-row flex-wrap items-start md:items-center font-semibold text-secondary gap-4 p-4 bg-white rounded-lg shadow-md">
            <div className="flex flex-col">
              <p className="text-lg md:text-xl flex items-center gap-x-1">
                <span className="font-semibold text-primary">🎂 Birthday:</span>{" "}
                <span className="text-gray-700">
                  {recipients &&
                    format(
                      new Date(recipients?.dob?.split("T")[0] + "T00:00:00"),
                      "do MMM yyyy"
                    )}{" "}
                  {/* {recipients?.dob} */}
                </span>
              </p>
              <p className="text-lg md:text-xl flex items-center gap-x-1">
                <span className="font-semibold text-primary">📧 Email:</span>
                <span className="text-gray-700">{recipients.email}</span>
              </p>
            </div>
            {/* {dateInputs} */}
          </div>
          <div className="flex flex-col mt-4 md:flex-row flex-wrap items-start md:items-center font-semibold text-secondary gap-4 p-4 bg-white rounded-lg shadow-md">
            <div className="flex flex-col w-full md:w-auto">
              <h2 className="text-xl font-bold text-primary mt-2">
                Events & Occasions
              </h2>
              <ul className="list-disc list-inside text-secondary mt-2 space-y-2">
                {dateInputs.length > 0 ? (
                  dateInputs
                ) : (
                  <li className="text-lg md:text-xl text-center text-gray-500">
                    No events or occasions to show
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="bg-[#F1F1F1] p-5 rounded-md my-5">
          <h3 className="text-2xl text-secondary font-semibold">
            Character Traits
          </h3>
          <div className="border-b-[1.5px] border-black my-5" />
          <div className="flex flex-wrap items-center gap-2">
            {recipients?.characterTraits?.map((trait, index) => (
              <button
                key={index}
                className="px-5 py-3 rounded-lg cursor-default w-fit md:px-10 bg-slate-50"
              >
                {trait}
              </button>
            ))}
          </div>
        </div>
        <div className=" p-5 rounded-md my-5">
          <h3 className="text-2xl text-secondary font-semibold">
            Order History
          </h3>
          <div className="border-b-[1.5px] border-black my-5" />
          {cards.length === 0 ? (
            <div>
              <h3 className="w-full text-2xl text-secondary font-semibold text-center">
                No Orders Placed Yet.
              </h3>
            </div>
          ) : (
            <div className="my-10">
              {isLoading ? (
                <div className="flex items-center justify-center h-full">
                  <Spinner size={"50"} text="Loading..." />
                </div>
              ) : (
                <MultiSwiper>
                  {cards?.map((card, index) => (
                    <SwiperSlide key={index}>
                      <div className="relative">
                        <div className="flex flex-col justify-center items-center relative my-5 flex-shrink-0 border rounded-md cursor-pointer hover:shadow-lg transition duration-300 ease-in-out">
                          {/* Card Image */}
                          <img
                            src={card.cardId?.thumbnail || card.thumbnail}
                            alt="placeholder_img"
                            className="w-74 rounded-md border-transparent hover:border hover:border-primary transition-all ease-in-out duration-300 sm:w-72 md:w-80 lg:w-96"
                            onLoad={handleImageLoad}
                            onError={handleImageError} // Handle error if image fails to load
                            onClick={() => {
                              setSelectedRecipient(card?.receiptsId?.fullName);
                              setCurrentEventId(card?.eventId);
                              setEventDate(card?.eventDate);
                              setCardDetails({
                                textCard: card.textCard,
                                cardStatus: card.status,
                                textTo: card.textTo,
                                textFrom: card.textFrom,
                                messageTheme: card.messageTheme,
                                createdAt: card.createdAt,
                                cardId: card.cardId,
                                receiptsId: card.receiptsId,
                                eventId: card.eventId,
                                eventOfRecipientId: card._id,
                              });
                              setSelectedCardThumbnail(card.cardId.thumbnail);
                              fetchCardDetails(
                                card.textTo,
                                card.textCard,
                                card.textFrom
                              );
                              setDetailsModal(true);
                            }}
                          />
                          {/* Card Content */}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </MultiSwiper>
              )}
            </div>
          )}
        </div>
      </div>
      {detailsModal && (
        <Modal toggleDetailsModal={toggleDetailsModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-secondary w-full px-6 py-4 mb-4 rounded-t-xl flex items-center justify-between shadow-lg">
              <h1 className="text-2xl text-white font-bold">Card Details</h1>
              <IoCloseSharp
                size={30}
                color="white"
                className="cursor-pointer hover:bg-gray-600 p-2 rounded-full"
                onClick={toggleDetailsModal}
              />
            </div>
            <div className="flex flex-col md:flex-row items-start justify-between p-6 w-full bg-white rounded-b-xl shadow-xl overflow-hidden">
              <div
                className="text-lg text-gray-800 w-full md:w-1/2 md:pr-4 space-y-4 overflow-auto"
                style={{ maxHeight: "500px" }}
              >
                {/* <div className="space-y-1">
                  <button
                    disabled={!canEdit}
                    className={`flex items-center justify-center gap-x-2 bg-primary text-white text-xl py-2.5 my-3 w-full rounded-xl ${
                      canEdit
                        ? "hover:bg-primary-dark"
                        : "cursor-not-allowed opacity-50"
                    }`}
                    onClick={() => editCard(cardDetails)} // Edit button functionality
                  >
                    Edit
                  </button>
                </div> */}
                <div className="space-y-1">
                  <label className="font-bold">Status:</label>
                  <span
                    className={`capitalize ml-2 p-1 rounded text-sm ${
                      cardDetails.cardStatus === "completed"
                        ? "bg-green-200 text-green-800"
                        : "bg-orange-200 text-orange-800"
                    }`}
                  >
                    {cardDetails.cardStatus}
                  </span>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Recipient:</label>
                  <div className="ml-2 p-1 rounded bg-blue-100 text-blue-800">
                    {selectedRecipient}
                  </div>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Event:</label>
                  <div className="ml-2 p-1 rounded bg-orange-100 text-orange-800">
                    {recipients?.eventsId?.map((item, index) => {
                      if (item._id === currentEventId) {
                        return (
                          <span key={index}> {item.name || "Event Name"} </span>
                        );
                      }
                    })}
                  </div>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Event Date:</label>
                  <div className="ml-2 p-1 rounded bg-teal-100 text-teal-800">
                    {eventDateWithCurrentYear &&
                      format(eventDateWithCurrentYear, "do MMM yyyy")}
                  </div>
                </div>
              </div>
              <div className="relative flex flex-col items-center justify-center w-full md:w-1/2">
                {imageLoading[currentPage] && (
                  <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white bg-opacity-75 z-10">
                    <Spinner props="Loading..." size={"50px"} />
                  </div>
                )}
                <div
                  className="image-display mb-1"
                  style={{
                    maxWidth: "5in",
                    maxHeight: "7in",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  <img
                    src={getImgSrc(currentPage)}
                    alt={`Page ${currentPage + 1} Image`}
                    className="rounded-xl shadow-lg max-w-xs h-auto"
                    style={{ maxWidth: "70%", maxHeight: "100%" }}
                    onLoad={() => handleImageLoad(currentPage)}
                    onError={() => handleImageLoad(currentPage, true)}
                  />
                </div>
                <div className="slider-controls flex justify-center">
                  <button
                    onClick={() => setCurrentPage((currentPage - 1 + 3) % 3)}
                    className="mx-2 py-1 px-4 rounded-full bg-gray-300 hover:bg-gray-400"
                    aria-label="Previous image"
                  >
                    {"<"}
                  </button>
                  <span className="px-4 py-2 text-lg font-semibold text-gray-700 rounded-xl">
                    {currentPage + 1} / 3
                  </span>
                  <button
                    onClick={() => setCurrentPage((currentPage + 1) % 3)}
                    className="mx-2 py-1 px-4 rounded-full bg-gray-300 hover:bg-gray-400"
                    aria-label="Next image"
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {removeModal && (
        <ConfirmationModal
          title="Remove Recipient"
          message="Are you sure you want to remove this Recipient from Address Book?"
          imageSrc={remove_recipient}
          onConfirm={() => handleDeleteRecipient(selectedID)}
          onCancel={toggleRemoveModal}
          confirmText="Yes"
          cancelText="No"
          toggleModal={toggleRemoveModal}
        />
      )}
    </section>
  );
};

export default RecipientDetails;
